export const DEFAULT_DARK_WIDTH = '0px'
export const DEFAULT_LIGHT_WIDTH = '0px'
export const ONE_HUNDRED_PERCENT = 100
export const ANIMATION_DELAY_MS = 10
